















































































import { Component, Prop } from 'vue-property-decorator';
import {
    CONTRACTS,
    FetchServiceContract
} from '@/core/contracts';
import DxPopup from 'devextreme-vue/popup';
import DxButton from 'devextreme-vue/button';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { ResourceTypeTree, ResourceType, ResourceTypeRelation } from '@/dto';
import { getNodesFlattenRecursive } from '@/core/components/tree/treeHelpers';
import Tree from '@/core/components/tree';
import DevExpress from 'devextreme/bundles/dx.all';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';
import { guid } from '@/core/helpers';
import DxValidator, {
    DxRequiredRule,
    DxCustomRule
} from 'devextreme-vue/validator';
import DxTextBox from 'devextreme-vue/text-box';
import DxTreeView from 'devextreme-vue/tree-view';
import Validators from '@/core/helpers/validators';
import DataSource from 'devextreme/data/data_source';
import InfiniteTreeView from './InfiniteTreeView.vue';
import { find } from 'lodash';

@Component({
    components: {
        DxPopup,
        DxButton,
        DxTextBox,
        DxValidator,
        DxCustomRule,
        DxRequiredRule,
        InfiniteTreeView
    }
})
export default class ResourceTypesListEditingPage extends Validators {
    private resourceTypeRelations: ResourceTypeRelation[] = [];
    private tree: DxTreeView | null = null;
    private resourceType: ResourceType = {
        id: '',
        name: '',
        alias: ''
    };
    private displayExpr: string = 'name';
    private keyExpr: string = 'treeId';
    private updated: boolean = false;
    private visible: boolean = false;
    private addMode: boolean = false;
    private selectedItems: ResourceTypeTree[] = [];

    @Inject(CONTRACTS.FetchService) private _fetchService?: FetchServiceContract;

    public get popup() {
        const name = 'popup';
        const popup = this.$refs[name] as unknown;
        return popup as DxPopup;
    }

    public get treeInstance() {
        return this.tree!.instance!;
    }

    public get infiniteTree() {
        const name = 'infinite-tree';
        const popup = this.$refs[name] as unknown;
        return popup as InfiniteTreeView;
    }

    public get dataSource() {
        return new DataSource({
            loadMode: 'processed',
            key: 'treeId',
            load: this.load
        });
    }

    public updateSelection(items: ResourceTypeTree[]) {
        this.selectedItems = items;
    }

    public async load(parameters: any) {
        const currentContextId = ContextsState.currentContextId;
        let parentId = '';
        if (parameters) {
            if (parameters.parentId) {
                parentId = parameters!.parentId[0];
            } else {
                if (typeof parameters.filter[0] === 'object') {
                    parentId = parameters.filter[1][1];
                } else {
                    parentId = parameters.filter[1];
                }
            }
        }
        const url = `/contexts/${currentContextId}/resourceTypesList/${parentId}`;
        return await this._fetchService!.get<ResourceTypeTree[]>(url);
    }

    public get title() {
        if (this.addMode) {
            return localize('ResourceTypes_AddResourceType');
        } else {
            return localize('ResourceTypes_EditResourceType');
        }
    }

    public showPopUp(treeItem: ResourceTypeTree | null, mode: boolean) {
        this.addMode = mode;
        this.resourceTypeRelations = [];

        if (this.addMode || !treeItem) {
            this.resourceType = {
                id: guid(),
                alias: '',
                name: ''
            };
        } else {
            this.resourceType = {
                id: treeItem.id,
                alias:  treeItem.alias,
                name:  treeItem.name
            };

            this.getChildren(treeItem.alias);
        }
        this.visible = true;
    }

    private validate() {
        const validName = this.validateInput('validatorName');
        let validAlias = false;

        if (this.addMode) {
            validAlias = this.validateInput('validatorAlias');
        } else {
            validAlias = true;
        }

        return validName && validAlias;
    }

    private get localize() {
        return localize;
    }

    private get buildRelations() {
        const resourceType = [];
        const relations: ResourceTypeRelation[] = [];

        this.selectedItems.forEach((item: ResourceTypeTree) => {
            const presented = this.resourceTypeRelations.find(x => x.resourceTypeGroupId === item.alias);
            if (!presented) {
                const relation: ResourceTypeRelation = {
                    id: guid(),
                    resourceTypeId: this.resourceType!.alias,
                    resourceTypeGroupId: item.alias
                };
                relations.push(relation);
            }
        });

        this.resourceTypeRelations.forEach((item: ResourceTypeRelation) => {
            const presented = this.selectedItems.find(x => x.alias === item.resourceTypeGroupId);
            const loaded = this.infiniteTree.getAllNodes
                                                   .find(x => x.alias === item.resourceTypeGroupId);
            if (!presented && loaded) {
                const relation: ResourceTypeRelation = {
                    id: item.id,
                    resourceTypeId: item.resourceTypeId,
                    resourceTypeGroupId: item.resourceTypeGroupId,
                    IsDeleted: true
                };
                relations.push(relation);
            }
        });

        if (this.updated) {
            resourceType.push({
                id: this.resourceType!.alias,
                name: this.resourceType!.name
            });
        }

        const data = {
            ResourceTypes_Partial: resourceType,
            ResourceTypeRelations_Partial: relations
        };

        return data;
    }

    private validateInput(name: string) {
        const element = this.$refs[name] as unknown;
        if (!element) {
            return false;
        }
        const validator = (element as DxValidator).instance!;
        return validator.validate().isValid !== undefined ? validator.validate().isValid! : false;
    }

    private changed() {
        this.updated = true;
    }

    private saveOnClick() {
        if (this.validate()) {
            this.sendResourceType();
            this.visible = false;
        }
    }

    private closeOnClick() {
        this.visible = false;
    }

    private async sendResourceType() {
        const currentContextId = ContextsState.currentContextId;
        const url = `/files/contexts/${currentContextId}?ignoreWarnings=true`;
        const items = this.selectedItems;
        const data = this.buildRelations;
        return await this._fetchService!.post<ResourceType>(
            url,
            JSON.stringify(data)
        );
    }

    private async getChildren(resourceTypeId: string) {
        const currentContextId = ContextsState.currentContextId;
        const relationsURL = `/contexts/${currentContextId}/resourceTypesList/relations/${resourceTypeId}`;
        this.resourceTypeRelations = await this._fetchService!.get<ResourceTypeRelation[]>(relationsURL)
        .then(res => {
            return res.filter(x => x.resourceTypeId === resourceTypeId);
        });
    }
}
